import {Component, Input} from '@angular/core';
import {ExcTranslation} from 'exc-core-v2';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ApplicationService} from '../../services/application.service';

@Component({
  selector: 'app-tab-task-flowtable',
  templateUrl: './tab-task-flowtable.component.html',
  styles: [
  ]
})
export class TabTaskFlowtableComponent extends ExcTranslation {
  @Input()
  SummaryFlowTable: any;
  @Input()
  ConfigFlowTable: any;
  @Input()
  Events: ExgEventArgs | any;

  localConfig = {
    openLink: (row: any): void => {
      this.appSvc.LinkedObject.OpenLink(row, {Events: this.Events});
    },
  };

  constructor(
    private appSvc: ApplicationService
  ) {
    super();
  }
}
